import { criancaFunc, servicoAcolhimentoFunc, servicos } from "../../helpers/Funcionalidades";


export const handleVerifyRedirectPendenciaServico = (valuesProps, valuesPropsPencia, history, idServico, redirect, roleKeycloack, user, idPJ) => {

  let pagina;

  const idAba = valuesProps;
  const idTipoPendencia = valuesPropsPencia;

  const validDadosPrincipaisAbas = new Set([13]);
  const validPerfilAbas = new Set([14])
  const validGestaoAbas = new Set([15]);
  const validRegularidadeAbas = new Set([16]);
  const validPlanejamentoAbas = new Set([17]);
  const validEquipeAbas = new Set([18]);
  const validRedeReferenciaAbas = new Set([19]);
  const validApadrinhamentoAbas = new Set([20]);

  const validRegularidadePendencias = new Set([59]);


  const hasOrgao = ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
    roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
    user?.orgaoExterno?.includes(idPJ));

  const hasOrgaoNoConselho = (roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento)) &&
    user?.orgaoExterno?.includes(idPJ);

  const dadosPrincipaisPersmissaoEditar = roleKeycloack?.includes(servicoAcolhimentoFunc.editar)
  const regularidadePersmissaoEditar = roleKeycloack?.includes(servicos.regularidadeEditar)


  if (validDadosPrincipaisAbas.has(idAba)) {
    if (!hasOrgao && !dadosPrincipaisPersmissaoEditar) {
      pagina = ""
    } else {
      pagina = "/editar"
    }
  } else if (validApadrinhamentoAbas.has(idAba)) {
    pagina = "/cadastrar-apadrinhamento"
  } else if (validPerfilAbas.has(idAba)) {
    pagina = "/cadastrar-perfil"
  } else if (validGestaoAbas.has(idAba)) {
    pagina = "/cadastrar-gestao"
  } else if (validRegularidadeAbas.has(idAba)) {
    if (validRegularidadePendencias.has(idTipoPendencia)) {
      pagina = "/cadastrar-regularidade"
    } else {
      if (!hasOrgaoNoConselho && !regularidadePersmissaoEditar) {
        pagina = "/visualizar-regularidade"
      } else {
        pagina = "/editar-regularidade"
      }
    }

  } else if (validPlanejamentoAbas.has(idAba)) {
    pagina = "/cadastrar-planejamento"
  } else if (validEquipeAbas.has(idAba)) {
    pagina = "/visualizar-equipe"
  } else if (validRedeReferenciaAbas.has(idAba)) {
    pagina = "/cadastrar-rede-de-referencia"
  }

  if (typeof pagina === "string") {
    if (redirect) {
      history.push(`/servico-acolhimento${pagina}/${idServico}?idAba=${idAba}&idTipoPendencia=${idTipoPendencia}`);
    }
    return true;
  }
  return false;
};